export function flattenSubmission(submission) {
  var _submission$field$vie, _submission$field$vie2;
  const label = (_submission$field$vie = submission.field.view) == null ? void 0 : _submission$field$vie.label;
  const fieldType = (_submission$field$vie2 = submission.field.view) == null ? void 0 : _submission$field$vie2.fieldType;
  const value = submission.value;
  return {
    label,
    fieldType,
    value
  };
}
//# sourceMappingURL=field-preview.js.map